"use client";

import { Brain, Globe, MessageCircle, RefreshCw, ShieldCheck, Users } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function Advantage() {
  const features = [{
    icon: Globe,
    title: "Transparent Pricing",
    description: "Clear, flat-fee pricing based on square footage so you know exactly what to expect.",
    tint: "bg-white",
    haloTint: "bg-blue-50"
  }, {
    icon: Brain,
    title: "Permit-Ready Drawings",
    description: "Comprehensive, professional plans that include all necessary revisions until your permit is issued.",
    tint: "bg-slate-50",
    haloTint: "bg-blue-50"
  }, {
    icon: MessageCircle,
    title: "Fast Turnaround",
    description: "Efficient design processes designed to get your project from concept to construction quickly.",
    tint: "bg-white",
    haloTint: "bg-blue-50"
  }, {
    icon: Users,
    title: "One-Stop Solution",
    description: "A seamless, end-to-end design experience managed by a single point of contact.",
    tint: "bg-slate-50",
    haloTint: "bg-blue-50"
  }, {
    icon: ShieldCheck,
    title: "Contemporary Expertise",
    description: "Specialized knowledge in modern residential architecture and complex site solutions.",
    tint: "bg-white",
    haloTint: "bg-blue-50"
  }, {
    icon: RefreshCw,
    title: "Attentive Service",
    description: "Personalized, collaborative design support that welcomes your unique vision and style.",
    tint: "bg-slate-50",
    haloTint: "bg-blue-50"
  }];
  return <section data-section-id="7634" id="the-acumen-advantage" className="bg-white py-24 md:py-32">
      <div className="max-w-[1240px] mx-auto px-5 sm:px-8 lg:px-14">

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 mb-16 md:mb-20">
          <div data-scroll-item className="lg:col-span-5">
            <h2 className="font-default font-semibold text-neutral-900 text-[clamp(2.125rem,3.2vw+0.5rem,3.25rem)] leading-[1.1] tracking-tight">
              Design that{" "}
              <em className="font-default font-semibold text-blue-600 not-italic">
                <span className="italic">elevates</span>
              </em>{" "}
              your vision.
            </h2>
          </div>

          <div data-scroll-item className="lg:col-span-7 lg:pt-3">
            <p className="text-neutral-700 text-[clamp(1.0625rem,0.4vw+1rem,1.1875rem)] leading-[1.6] font-default">
              Acumen D&B combines architectural precision with a streamlined, client-focused process. From initial site analysis to final permit-ready documentation, we remove the complexity of residential design to ensure your project is both beautiful and buildable.
            </p>
            <Link to="/HomePage" className="inline-block mt-6 text-neutral-900 font-default font-medium underline decoration-blue-600 decoration-[1.5px] underline-offset-4 hover:decoration-[2.5px] transition-all duration-200">
              View our design process
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-scroll-item className={`group ${feature.tint} rounded-lg p-8 shadow-sm hover:shadow-md transition-shadow duration-[280ms] ease-out border border-neutral-200`}>
                <div className={`${feature.haloTint} w-14 h-14 rounded-lg flex items-center justify-center mb-6 transition-all duration-[280ms] ease-out group-hover:w-[60px] group-hover:h-[60px] group-hover:brightness-95`}>
                  <Icon className="w-6 h-6 text-blue-600" strokeWidth={1.75} />
                </div>
                <h3 className="font-default font-semibold text-neutral-900 text-[clamp(1.25rem,0.8vw+1rem,1.5rem)] leading-[1.25] tracking-tight mb-3">
                  {feature.title}
                </h3>
                <p className="font-default text-neutral-700 text-base leading-[1.65]">
                  {feature.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}